<div class="name-dialog w400">
  <h1 mat-dialog-title>{{ data.title }}</h1>
  <mat-dialog-content class="name-content">
    <mat-form-field appearance="outline" class="w100">
      <mat-label>Name der Sammelmappe</mat-label>
      <input (keyup.enter)="submit()" [formControl]="nameCtrl" cdkFocusInitial matInput required type="text">
      @if (nameCtrl.hasError('required') && nameCtrl.touched) {
        <mat-error>Name ist verpflichtend</mat-error>
      }
      @if (nameCtrl.hasError('maxlength')) {
        <mat-error>Nur {{ maxLength }} Zeichen erlaubt</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-dialog-close mat-raised-button>Abbrechen</button>
    <button (click)="submit()" color="primary" mat-raised-button>{{ data.action }}</button>
  </mat-dialog-actions>
</div>
